import { fetchApi } from '../api';
import type {
  ActionHorizon,
  BottlenecksResponse,
  ComplianceKpisResponse,
  SoDeliverySimulationListResponse,
  SoDeliverySimulationDetail,
} from './complianceMonitor.types';

class ComplianceMonitorService {
  async listSoDeliverySimulations(params?: {
    page?: number;
    page_size?: number;
    include_reviewed?: boolean;
    search_order?: string;
    order_status?: string;
    simulation_status?: 'in_line' | 'out_of_plan';
    action_horizon?: ActionHorizon[];
  }): Promise<SoDeliverySimulationListResponse> {
    const queryParams: Record<string, string | number | boolean> = {};
    if (params?.page) queryParams.page = params.page;
    if (params?.page_size) queryParams.page_size = params.page_size;
    if (params?.include_reviewed !== undefined) queryParams.include_reviewed = params.include_reviewed;
    if (params?.search_order) queryParams.search_order = params.search_order;
    if (params?.order_status) queryParams.order_status = params.order_status;
    if (params?.simulation_status) queryParams.simulation_status = params.simulation_status;
    if (params?.action_horizon && params.action_horizon.length > 0) {
      queryParams.action_horizon = params.action_horizon.join(',');
    }
    return fetchApi<SoDeliverySimulationListResponse>('compliance_monitor/so-delivery-simulations/', {
      params: queryParams,
    });
  }

  async getSoDeliverySimulation(simulationId: number): Promise<SoDeliverySimulationDetail> {
    return fetchApi<SoDeliverySimulationDetail>(`compliance_monitor/so-delivery-simulations/${simulationId}/`);
  }

  async getProgrammedRiskDetail(salesOrderId: number): Promise<SoDeliverySimulationDetail> {
    return fetchApi<SoDeliverySimulationDetail>(`compliance_monitor/programmed-risk/${salesOrderId}/`);
  }

  async markSoDeliverySimulationReviewed(simulationId: number, reviewed: boolean): Promise<{
    success: boolean;
    reviewed: boolean;
    reviewed_at: string | null;
  }> {
    return fetchApi(`compliance_monitor/so-delivery-simulations/${simulationId}/review/`, {
      method: 'PATCH',
      body: { reviewed },
    });
  }

  async getKpis(): Promise<ComplianceKpisResponse> {
    return fetchApi<ComplianceKpisResponse>('compliance_monitor/kpis/');
  }

  async getBottlenecks(limit = 10): Promise<BottlenecksResponse> {
    return fetchApi<BottlenecksResponse>('compliance_monitor/bottlenecks/', {
      params: { limit },
    });
  }
}

export const complianceMonitorService = new ComplianceMonitorService();

